import { ref } from "vue";
import store from "@/store";
import { createDelivery, deleteDelivery, getProcessFinished } from "@/http";
import { sendEventStageProcess } from "@/socket";

const process = ref(null);
const payload = ref({
  type_delivery: "",
  delivery: "",
  observer: "",
});

function setProcess(item) {
  process.value = item;
  payload.value.delivery = store.state.userCurrent?.id;
}

function closeDelivery() {
  process.value = null;
  payload.value = { type_delivery: "", delivery: "", observer: "" };
}

async function sendDelivery(onSuccess) {
  if (!process.value?.id) return;

  const requestDelivery = await createDelivery(payload.value);
  if (!requestDelivery?.id) return;

  const data = await getProcessFinished(process.value.id, {
    delivery: requestDelivery.id,
  });

  if (data?.status) {
    process.value.stage = "C";
    sendEventStageProcess("graphic", process.value);
    closeDelivery();
    document.getElementById("closeButtonDelivery")?.click();
    if (onSuccess) await onSuccess();
  } else {
    await deleteDelivery(requestDelivery.id);
  }
}

export function useDelivery() {
  return { process, payload, setProcess, closeDelivery, sendDelivery };
}